module.exports = __webpack_public_path__ + "img/left-arrow-dark.7012b507.svg";